import React from "react";
import Modal from "react-modal";
import { customModalStyles } from "../../../_shared/components/Modal/ModalStyles";
import "./TickerModal.scss";

Modal.setAppElement("#root");

function MoneylineModal({ moneylineStatsObj, moneylineModal, setMoneylineModal, cell }) {
    const rowStyle = {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
    };
    const cellStyle = {
        width: "20%",
        textAlign: "center",
        height: 40,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
    };
    const firstColumnStyle = {
        marginLeft: 5,
        marginRight: -5,
        width: "30%",
    };
    return (
        <Modal
            isOpen={moneylineModal}
            onRequestClose={() => {
                setMoneylineModal(false);
            }}
            style={{
                ...customModalStyles,
                content: {
                    ...customModalStyles.content,
                    maxHeight: 260,
                    minHeight: 260,
                    overflow: "hidden",
                },
            }}
            contentLabel="Ticker Modal"
        >
            <div
                className="longbow-modal"
                style={{
                    width: 450,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 10,
                        margin: 15,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        <img
                            className={"tickerImage"}
                            style={{
                                height: 25,
                                width: 25,
                                borderRadius: 5,
                            }}
                            src={`https://files.mylongbow.com/icons/${cell.row.original.ticker.split(" ")[0]
                                }.jpeg`}
                            onError={(e) => {
                                e.target.src =
                                    "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
                            }}
                        />
                        <div style={{ fontSize: 14 }}>
                            {cell.row.original.ticker}
                        </div>
                    </div>
                    <div
                        style={{
                            fontSize: 16,
                            fontWeight: 800,
                            position: "absolute",
                            left: "calc(50% - 45px)",
                        }}
                    >
                        Moneyline Stats
                    </div>
                    <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            setMoneylineModal(false);
                        }}
                    >
                        ×
                    </div>
                </div>
                <div style={{ marginTop: 20 }}>
                    <div
                        style={{ display: "flex", flexDirection: "row", width: "100%" }}
                    >
                        <div style={{ ...cellStyle, ...firstColumnStyle }}></div>
                        <div style={cellStyle}>1D</div>
                        <div style={cellStyle}>2D</div>
                        <div style={cellStyle}>3D</div>
                        <div style={cellStyle}>4D</div>
                        <div style={cellStyle}>5D</div>
                    </div>
                    <div style={{ ...rowStyle, backgroundColor: "#222" }}>
                        <div style={{ ...cellStyle, ...firstColumnStyle }}>Win %</div>
                        <div style={{ ...cellStyle, color: "white" }}>
                            {(moneylineStatsObj?.[`d0`]?.[`win_pct`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "white" }}>
                            {(moneylineStatsObj?.[`d1`]?.[`win_pct`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "white" }}>
                            {(moneylineStatsObj?.[`d2`]?.[`win_pct`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "white" }}>
                            {(moneylineStatsObj?.[`d3`]?.[`win_pct`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "white" }}>
                            {(moneylineStatsObj?.[`d4`]?.[`win_pct`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                    </div>
                    <div style={rowStyle}>
                        <div style={{ ...cellStyle, ...firstColumnStyle }}>
                            Avg % Gain
                        </div>
                        <div style={{ ...cellStyle, color: "green" }}>
                            {`+${(
                                moneylineStatsObj?.[`d0`]?.[`avg_pct_gain`] * 100
                            ).toFixed(1)}`.replace("+NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "green" }}>
                            {`+${(
                                moneylineStatsObj?.[`d1`]?.[`avg_pct_gain`] * 100
                            ).toFixed(1)}`.replace("+NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "green" }}>
                            {`+${(
                                moneylineStatsObj?.[`d2`]?.[`avg_pct_gain`] * 100
                            ).toFixed(1)}`.replace("+NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "green" }}>
                            {`+${(
                                moneylineStatsObj?.[`d3`]?.[`avg_pct_gain`] * 100
                            ).toFixed(1)}`.replace("+NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "green" }}>
                            {`+${(
                                moneylineStatsObj?.[`d4`]?.[`avg_pct_gain`] * 100
                            ).toFixed(1)}`.replace("+NaN", "--")}
                        </div>
                    </div>
                    <div style={{ ...rowStyle, backgroundColor: "#222" }}>
                        <div style={{ ...cellStyle, ...firstColumnStyle }}>Loss %</div>
                        <div style={{ ...cellStyle, color: "white" }}>
                            {(moneylineStatsObj?.[`d0`]?.[`loss_pct`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "white" }}>
                            {(moneylineStatsObj?.[`d1`]?.[`loss_pct`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "white" }}>
                            {(moneylineStatsObj?.[`d2`]?.[`loss_pct`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "white" }}>
                            {(moneylineStatsObj?.[`d3`]?.[`loss_pct`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "white" }}>
                            {(moneylineStatsObj?.[`d4`]?.[`loss_pct`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                    </div>
                    <div style={rowStyle}>
                        <div style={{ ...cellStyle, ...firstColumnStyle }}>
                            Avg % Loss
                        </div>
                        <div style={{ ...cellStyle, color: "red" }}>
                            {(moneylineStatsObj?.[`d0`]?.[`avg_pct_loss`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "red" }}>
                            {(moneylineStatsObj?.[`d1`]?.[`avg_pct_loss`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "red" }}>
                            {(moneylineStatsObj?.[`d2`]?.[`avg_pct_loss`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "red" }}>
                            {(moneylineStatsObj?.[`d3`]?.[`avg_pct_loss`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                        <div style={{ ...cellStyle, color: "red" }}>
                            {(moneylineStatsObj?.[`d4`]?.[`avg_pct_loss`] * 100)
                                .toFixed(1)
                                .replace("NaN", "--")}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
export default React.memo(MoneylineModal);
